import { useMutation } from '@tanstack/react-query';

import { companyIdState } from '../company.state';
import { useCompanyFetchMode } from '../company-fetch-context';
import type { EditCompanyFundingsPayload } from '@/api/v4/organization.api';
import { editCompanyFundings } from '@/api/v4/organization.api';
import { queryClient, QueryKey } from '@/config/query-client';
import { notify } from '@/ui/snackbar/notify';
import { useTranslation } from 'react-i18next';
import { useAtomValue } from 'jotai';

export const useEditCompanyFundings = () => {
  const { t } = useTranslation('default');
  const companyId = useAtomValue(companyIdState);
  const fetchMode = useCompanyFetchMode();

  return useMutation({
    mutationFn: async (payload: EditCompanyFundingsPayload) =>
      companyId ? editCompanyFundings(companyId, payload) : undefined,
    onSuccess: async () => {
      await queryClient.invalidateQueries({
        queryKey: [QueryKey.CompanyFundings, fetchMode, companyId],
      });
    },
    onError: () => {
      notify({
        message: t`default:unknownError`,
      });
    },
  });
};
